/* eslint-disable new-cap */
import Loadable from 'react-loadable';

import Loader from './Loader';

const Dashboard = Loadable({
  loader: () => import('../views/I9/pages/Dashboard'),
  loading: Loader,
});

const Programme = Loadable({
  loader: () => import('../views/I9/pages/Programme'),
  loading: Loader,
});

const Promoteur = Loadable({
  loader: () => import('../views/I9/pages/Promoteur'),
  loading: Loader,
});

const Lot = Loadable({
  loader: () => import('../views/I9/pages/Lot'),
  loading: Loader,
});

const Vente = Loadable({
  loader: () => import('../views/I9/pages/Vente'),
  loading: Loader,
});

const Facture = Loadable({
  loader: () => import('../views/I9/pages/Facture'),
  loading: Loader,
});

const Resource = Loadable({
  loader: () => import('../views/I9/pages/Resource'),
  loading: Loader,
});

const ResourceList = Loadable({
  loader: () => import('../views/I9/pages/ResourceList'),
  loading: Loader,
});

export default [
  { path: '/i9/programmes/:id', name: 'I9Programme', component: Programme },
  { path: '/i9/lots/:id', name: 'I9Programme', component: Lot },
  { path: '/i9/promoteurs/:id', name: 'I9Promoteur', component: Promoteur },
  { path: '/i9/ventes/:id', name: 'I9Vente', component: Vente },
  { path: '/i9/factures/:id', name: 'I9Factures', component: Facture },
  { path: '/i9/:resource/:id', name: 'I9Resource', component: Resource },
  { path: '/i9/:resource', name: 'I9ResourceList', component: ResourceList },
  { path: '/i9', name: 'I9', component: Dashboard },
];
